import { useEffect, useState } from "react";
import { getLessons } from "@/lib/api";

// Custom hook: fetches lessons for a track.
export function useLessons(track) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!track) return undefined;
    let cancelled = false;
    setLoading(true);
    setError(null);
    getLessons(track)
      .then((res) => {
        if (!cancelled) setData(res);
      })
      .catch((e) => {
        if (!cancelled) setError(e);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [track]);

  return { data, loading, error };
}
